export default __webpack_public_path__ + "static/media/virtualpad_bt_l3.04081d16.png";